const RESET_PASSWORD_FORM = {
  password: 'password',
  confirmPassword: 'confirmPassword'
} as const;

const RESET_PASSWORD_FORM_DEFAULT_VALUE = {
  password: '',
  confirmPassword: ''
} as const;

const PASSWORD_RULE_KEYS = {
  minLength: 'minLength',
  lowercaseChar: 'lowercaseChar',
  numberChar: 'numberChar',
  specialChar: 'specialChar'
} as const;

const PASSWORD_RULES = [
  {
    id: PASSWORD_RULE_KEYS.minLength,
    message: 'At least 8 characters long',
    test: (value: string) => value.length >= 8
  },
  {
    id: PASSWORD_RULE_KEYS.lowercaseChar,
    message: 'At least one lowercase letter',
    test: (value: string) => /[a-z]/.test(value)
  },
  {
    id: PASSWORD_RULE_KEYS.numberChar,
    message: 'At least one number',
    test: (value: string) => /\d/.test(value)
  },
  {
    id: PASSWORD_RULE_KEYS.specialChar,
    message: 'At least one special character',
    test: (value: string) => /[^A-Za-z0-9]/.test(value)
  }
];

export {
  RESET_PASSWORD_FORM,
  RESET_PASSWORD_FORM_DEFAULT_VALUE,
  PASSWORD_RULES,
  PASSWORD_RULE_KEYS
};
